import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import { BreadcrumbsItem, LayoutSidebarSubnav } from 'core/components';

import PageVaultRadar from 'hcp/components/page/vault-radar';

<template>
  {{#let (t "components.page.vault-radar.title") as |title|}}

    {{pageTitle title}}

    <BreadcrumbsItem
      @route="cloud.services.vault-radar"
      @text={{t "components.page.vault-radar.breadcrumb-title"}}
    />

    <PageVaultRadar
      @tenantData={{@controller.model.tenantData}}
      @hasExistingTenant={{@controller.model.hasExistingTenant}}
      @canProvisionTenant={{@controller.model.canProvisionTenant}}
    />

    <LayoutSidebarSubnav data-test-vault-radar-sidebar-subnav as |Subnav|>
      <Subnav.BackLink
        @text={{t "nav.back-to-cloud-dashboard"}}
        @route="cloud.orgs.detail.projects.detail.index"
        @models={{array @model.organization.id @model.project.id}}
        data-test-vault-radar-subnav-link-back
      />

      <Subnav.Title data-test-vault-radar-subnav-title>
        {{t "nav.project.radar"}}
      </Subnav.Title>

      <Subnav.Link
        @text={{t "components.page.vault-radar.overview.title"}}
        @route="cloud.services.vault-radar"
        data-test-vault-radar-subnav-link-overview
      />
    </LayoutSidebarSubnav>
  {{/let}}
</template>
